import { useEffect } from 'react';
import { useTitle, useMediaQuery } from '../HooksPublic';
import { CDN_URL } from '../ConfigPublic';

import '../style/about_us.scss';

var AboutUs = () => {
	var { setTitle } = useTitle();
	var isMobile = useMediaQuery('(max-width: 600px)');

	useEffect(() => {
		setTitle('Nosotros | COCOAN', false);
	}, [setTitle]);

	return (
		<main className='co about-us-screen'>
			<header className='about-us-hero'>
				<img src={isMobile ? `${CDN_URL}/static/about_us/BANNER_ABOUTUS_MOBILE.webp` : `${CDN_URL}/static/about_us/BANNER_ABOUTUS.webp`} alt='Nuestra Historia' className='hero-bg' />
				<div className='hero-overlay'>
					<h1>
						<span className="font-graphik">Nuestra </span>
						<span className="font-homemade-apple">historia</span>
					</h1>
				</div>
			</header>

			<section className="section-container">
				<div className="grid-two-columns dark-bg">
					<div className="info-column">
						<h2>
							<span className="font-graphik">Chocolatería</span><br />
							<span className="font-homemade-apple">sincera</span>
						</h2>
						<p className="description">
							Durante diez años hemos cultivado una misma filosofía: crear chocolate 100% sincero.
						</p>
						<p className="description">
							Seleccionamos ingredientes excepcionales, perfeccionamos cada detalle y honramos el origen de cada sabor para ofrecer una experiencia auténtica, sofisticada y memorable.
						</p>
					</div>
					<div className="image-column">
						<img src={`${CDN_URL}/static/about_us/BANNER1.webp`} alt="Chocolatería sincera" />
					</div>
				</div>
			</section>

			<section className="section-container">
				<div className="grid-two-columns light-bg">
					<div className="image-column">
						<img src={`${CDN_URL}/static/about_us/COCOAN_SUC.webp`} alt="10 años de excelencia" />
					</div>
					<div className="info-column">
						<h2>
							<span className="font-graphik">10 años de excelencia</span><br />
							<span className="font-graphik">en cada </span>
							<span className="font-homemade-apple">detalle</span>
						</h2>
						<p className="description">
							Nuestra historia está hecha de dedicación, de estándares elevados y de una pasión constante por transformar el cacao en su expresión más extraordinaria.
						</p>
						<p className="description">
							A lo largo de estos diez años, hemos creado un espacio donde el sabor, la calidad y la dedicación convergen para dar vida a experiencias que se disfrutan con todos los sentidos.
						</p>
					</div>
				</div>
			</section>

			<section className="color-blocks-section">
				<div className="color-block block-image">
					<img src={`${CDN_URL}/static/about_us/IMGV1.webp`} alt="Momentos Compartidos" className="block-img" />
					<div className="block-overlay">
						<span className="block-text">
							<span className="font-graphik-light">Momentos</span> <br /> 
							<span className="font-graphik-bold">Compartidos</span>
						</span>
					</div>
				</div>
				<div className="color-block block-image">
					<img src={`${CDN_URL}/static/about_us/IMGV2.webp`} alt="Sabores Inigualables" className="block-img" />
					<div className="block-overlay">
						<span className="block-text">
							<span className="font-graphik-light">Sabores</span> <br /> 
							<span className="font-graphik-bold">Inigualables</span>
						</span>
					</div>
				</div>
				<div className="color-block block-image">
					<img src={`${CDN_URL}/static/about_us/IMGV3.webp`} alt="Momentos Especiales" className="block-img" />
					<div className="block-overlay">
						<span className="block-text">
							<span className="font-graphik-light">Momentos</span> <br /> 
							<span className="font-graphik-bold">Especiales</span>
						</span>
					</div>
				</div>
			</section>

			<section className="about-us-cta">
				<img src={`${CDN_URL}/static/about_us/ABOUTUS.webp`} alt="¿Listo para formar parte?" className="cta-bg" />
				<div className="cta-overlay">
					<h2>
						¿Listo para formar parte de esta<br />
						<span className="font-homemade-apple">gran historia</span>?
					</h2>
				</div>
			</section>
		</main>
	);
};

export default AboutUs;
